import React from "react";
import PropTypes from "prop-types";
import { images } from "@resourcehub/resourcehub-assets";
import styled from "@emotion/styled";

// Styles
import PageSectionWrapper from "./styles/PageSectionWrapper";
import SubTitleWrapper from "./styles/SubTitleWrapper";
import TitleWrapper, { TitleWrapperPropTypes } from "./styles/TitleWrapper";

// Obsolete
import GateForm from "../../components/obsolete/ContactFormNew/GateForm";
import ThanksModal from "../../components/obsolete/Modal/ThanksModal";
import { domainType, verticalType } from "../../types";

const Backdrop = styled.div`
    label: Backdrop;

    display: flex;
    flex-direction: column;
    > div:nth-of-type(2) {
        background: #1a97d4;
        color: #ffffff;
    }
`;
const BorderImageDiv = styled.div`
    label: BorderImageDiv;

    padding: 0;
    margin: 0;
    > img {
        vertical-align: bottom;
        width: 100vw;
        height: 5vw;
    }
`;
const ContactBody = styled.div`
    label: ContactBody;

    /* Extra small devices (phones, 600px and down) */
    @media only screen and (max-width: 600px) {
        min-width: 294px;
    }

    /* Small devices (portrait tablets and large phones, 600px and up) */
    @media only screen and (min-width: 600px) {
        min-width: 294px;
    }

    /* Medium devices (landscape tablets, 768px and up) */
    @media only screen and (min-width: 768px) {
        min-width: 80%;
        padding-left: 10%;
        padding-right: 10%;
    }

    /* Large devices (laptops/desktops, 992px and up) */
    @media only screen and (min-width: 1025px) {
        min-width: 80%;
        padding-left: 10%;
        padding-right: 10%;
    }

    /* Extra large devices (large laptops and desktops, 1200px and up) */
    @media only screen and (min-width: 1200px) {
        min-width: 80%;
        padding-left: 10%;
        padding-right: 10%;

        > section {
            margin-bottom: 40px;
        }
    }
`;
const ContactFormWrapper = styled.div`
    label: ContactFormWrapper;

    margin-bottom: 1rem;
`;

class ContactForm extends React.Component {
    state = {
        modalIsOpen: false
    };

    afterSubmit = () => {
        const { afterSubmit } = this.props;
        if (afterSubmit) {
            afterSubmit();
        } else {
            this.setState({
                modalIsOpen: true
            });
        }
    };

    closeModal = () => {
        this.setState({ modalIsOpen: false });
    };

    render() {
        const {
            title,
            title_align,
            title_theme,
            title_type,

            sub_title,
            sub_title_align,
            sub_title_theme,
            sub_title_type,

            thanks,
            domain,
            vertical,
            copyData,
            page
        } = this.props;
        const { modalIsOpen } = this.state;
        return (
            <>
                <ContactBody>
                    <TitleWrapper title_align={title_align} title_theme={title_theme} title_type={title_type}>
                        {title}
                    </TitleWrapper>
                    <SubTitleWrapper
                        title_align={sub_title_align}
                        title_theme={sub_title_theme}
                        title_type={sub_title_type}
                    >
                        {sub_title}
                    </SubTitleWrapper>
                    <ContactFormWrapper>
                        <GateForm
                            dataQaLocation="on-page"
                            domain={domain}
                            vertical={vertical}
                            page={page || "webpage"}
                            leadSourceMostRecent1="Contact Request"
                            afterSubmit={this.afterSubmit}
                            copyData={copyData}
                        />
                    </ContactFormWrapper>
                </ContactBody>
                <ThanksModal
                    thanksModalIsOpen={modalIsOpen}
                    closeThanksModal={this.closeModal}
                    pricing_thanks={thanks}
                />
            </>
        );
    }
}

const PageSectionContact = (props) => {
    if (props.showBackdrop) {
        return (
            <PageSectionWrapper data-qa="on-page-request-pricing-section">
                <Backdrop>
                    <BorderImageDiv>
                        <img src={images.pricingTopSvg} alt="section border" />
                    </BorderImageDiv>
                    <ContactForm {...props} />
                    <BorderImageDiv>
                        <img src={images.pricingBottomSvg} alt="section border" />
                    </BorderImageDiv>
                </Backdrop>
            </PageSectionWrapper>
        );
    }
    debugger;
    return (
        <PageSectionWrapper data-qa="on-page-request-pricing-section">
            <ContactForm {...props} />
        </PageSectionWrapper>
    );
};

PageSectionContact.defaultProps = {
    showBackdrop: true,
    page: "webpage"
};
PageSectionContact.propTypes = {
    thanks: PropTypes.string.isRequired,
    page: PropTypes.string,
    domain: domainType.isRequired,
    vertical: verticalType.isRequired,
    showBackdrop: PropTypes.bool,

    sub_title: PropTypes.string,
    sub_title_align: PropTypes.oneOf(["left", "center", "right"]),
    sub_title_theme: PropTypes.oneOf(["blue", "black", "white"]),

    ...TitleWrapperPropTypes
};

export default PageSectionContact;
